import React from 'react';
import { withRouter } from 'react-router-dom';
import { BoldOrParagraph, ClickableBoxWithUnderline } from '../Components';
import { getGenreParam } from '../utils/getSearchParam';
import { navigateToProductListWithGenre } from '../utils/navigations';
import { getTranslateByScope } from '../i18n';

export const translate = getTranslateByScope('app.genres');
export const Genre = withRouter(({
  history, value, ...props
}) => {
  const genre = getGenreParam(props.location);
  const isCurrent = genre === value;
  const onClick = () => {
    navigateToProductListWithGenre({
      genre: value,
      history,
    });
  };
  return (
    <ClickableBoxWithUnderline isUnderlined={isCurrent} onClick={onClick}>
      <BoldOrParagraph bold={isCurrent}>{translate(value)}</BoldOrParagraph>
    </ClickableBoxWithUnderline>
  );
});
